import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {siteUrl } from '../../constants/global';


const AskQuestion = () => {
    const modalPopupState = useSelector((state) => state.ModalPopupBucket);

    const [isActive, setIsActive] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isAnonymous,setIsAnonymous] = useState(false);
    const [questiontext,setQuestionText] = useState("");

    const ToggleClick = event => {
        setIsActive(current => !current);
    };

    /*********For Text fields*********/
    function handleTextAreaChange(e){
        console.log(e.target.value);
        setQuestionText(e.target.value);
    }

    /********Call Form API********/
    function callAskQuestionFormAPI(requestData,formID){

        setLoading(false);
        setIsAnonymous(false);
        setQuestionText("");

        var responseString = '<div class="wpcf7-response-output" aria-hidden="true">Thank you for your question. It has been sent.</div>';
        document.getElementById("contact-response").innerHTML = responseString;

        setTimeout(() => {
            document.getElementById("contact-response").innerHTML = "";
        }, 1000);
          
        /********Submit request demo/trial form***********/
        fetch(siteUrl+'/wp-json/contact-form-7/v1/contact-forms/'+formID+'/feedback',requestData)
        .then((response) => response.json())
        .then(function(actualData){ 

            //console.log(actualData.status+' -- '+actualData.message, 'meeeeeeeeeeeeee');
            if(actualData.status==="mail_sent"){
                // var responseString = '<div class="wpcf7-response-output" aria-hidden="true">'+actualData.message+'</div>';
                // document.getElementById("contact-response").innerHTML = responseString;
            }else if(actualData.status==="validation_failed"){
                var responseString = '<div class="wpcf7-response-output error-output" aria-hidden="true">'+actualData.message+'</div>';
                document.getElementById("contact-response").innerHTML = responseString;
            }else{
                var responseString = '<div class="wpcf7-response-output warning-output" aria-hidden="true">'+actualData.message+'</div>';
                document.getElementById("contact-response").innerHTML = responseString;
            }
              
        }).catch(rejected => {

        });

     }

    /*********Submit Ask Question*********/
    function submitAskQuestion(event){
        event.preventDefault();


        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageData = authlogin ? JSON.parse(authlogin) : "";

        var firstname = storageData.first_name ? storageData.first_name : "";
        var lastname = storageData.last_name ? storageData.last_name : "";
        var email = storageData.user_email;
        var sessionname = event.target.elements.sessionname.value;
        var questions = questiontext;
        

        var myHeaders = new Headers();
        var formdata = new FormData();
        /*******It Should have same field name which mentioned in contact form 7 in backend*********/
        formdata.append("user-first-name", firstname);
        formdata.append("user-last-name", lastname);
        formdata.append("your-email", email);
        formdata.append("session-name", sessionname);
        formdata.append("textarea-990", questions);

        /*******if any fields empty*******/
        if(!firstname || !email || !sessionname || !questions){
            setLoading(false);
            var responseString = '<div class="wpcf7-response-output error-output" aria-hidden="true">Facing some issue please refresh</div>';
            document.getElementById("contact-response").innerHTML = responseString;
            return false;
        }else{
            setLoading(true);
            setIsAnonymous(true);
        }
        
        var requestDemoOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
            };

        /*******call form api pass form id*********/
        var formID = 2076;
        callAskQuestionFormAPI(requestDemoOptions,formID);
    }

  return (
    <>
     
        <div className={isActive ? 'questions-box open' : 'questions-box'}>

            <button type="button" className="questions-btn" onClick={ToggleClick}><span className="material-icons-outlined">email</span> Ask a Question</button>

            <div className="chat-box">
                <div className="popup-header">Ask a Question</div>
                <div className="questions-form">
                    <form onSubmit={submitAskQuestion}>

                        <input type="hidden" name="sessionname" value={modalPopupState.data['feedback'].title} />
                        <div className="questions-form-row">
                            <textarea className="questions-textarea" onChange={(e) => handleTextAreaChange(e)} id="questions-textarea" name="questions" placeholder="Please post your question for the Resource Person to be answered." value={questiontext} />
                        </div>
                        <div className="questions-form-row">

                            <button type="submit" disabled={isAnonymous ? true : false} className="submit-btn">{loading && <span className="material-icons-outlined spin">motion_photos_on</span>} Submit</button>

                        </div>

                        
                        <div id="contact-response" className="contact-response">
                             {/********Response Message will append*********/}
                        </div>
                    </form>
                </div>
            </div>

        </div>

    </>
  )
};

export default AskQuestion;